import axios from '~/utils/axiosInstance';

export const postProjectBid = async function (data: any, id: string) {
  const response = await axios.post(`/projects/${id}/bid`, data);
  return response.data;
};

export const acceptProjectBid = async function (id: string, bidId: string) {
  const response = await axios.post(`/projects/${id}/bid/${bidId}/accept`);
  return response.data;
};

export const declineProjectBid = async function (id: string, data?: any) {
  const response = await axios.post(`/projects/${id}/bid/decline`, data ?? {});
  return response.data;
};

export const saveInvestorFeedback = async function (id: string, data: any) {
  const response = await axios.post(`/projects/${id}/bid/investor-feedback`, data);
  return response.data;
};

export const getBids = async function (
  id: string, 
  filters?: {
    investorId?: string;
    bidStatus?: string;
    parentProjectId?: string;
    limit?: number;
    offset?: number;
  }
) {
  const params = new URLSearchParams();
  
  if (filters?.investorId) {
    params.append('investorId', filters.investorId);
  }
  
  if (filters?.bidStatus) {
    params.append('bidStatus', filters.bidStatus);
  }
  
  if (filters?.parentProjectId) {
    params.append('parentProjectId', filters.parentProjectId);
  }
  
  if (filters?.limit) {
    params.append('limit', filters.limit.toString());
  }
  
  if (filters?.offset) {
    params.append('offset', filters.offset.toString());
  }

  const queryString = params.toString();
  const url = `/projects/${id}/getBids${queryString ? `?${queryString}` : ''}`;
  
  const response = await axios.get(url);
  return response.data;
};

export const updateProjectBid = async function (bidId: string, projectId: string, data: any) {
  const response = await axios.patch(`/projects/${projectId}/bid/${bidId}`, data);
  return response.data;
};
